import React                  from 'react';
import RestaurantBanner       from '../Header/RestaurantBanner';
import Header                 from '../Header/Header';
import CapabilitiesView       from './CapabilitiesView';

class RestaurantView extends React.Component {
    render() {
        return (<React.Fragment>
                <Header>
                    <RestaurantBanner />
                </Header>

                <div className="l-container">
                    <CapabilitiesView />
                </div>
            </React.Fragment>
        )
    }
}

export default RestaurantView;



// WEBPACK FOOTER //
// /src/components/RestaurantView/RestaurantView.js